<template>
    <section class="grid grid-cols-12">
        <img
            v-if="image"
            :src="image.url"
            :alt="image.alt"
            class="col-span-12 rounded-lg lg:col-span-8" />
        <AccordionBlock v-if="faq" v-bind="faq" class="col-span-12 lg:col-span-8" />
        <TextComponent v-if="text" v-bind="text" class="col-span-12 lg:col-span-4" />
    </section>
</template>
<script lang="ts" setup>
import type {
    FaqComponentModel,
    ImageComponentModel,
    SixtyFourtyComponentModel,
    TextBlockComponentModel,
} from '@su4r-frontend/api';

const { components } = defineProps<SixtyFourtyComponentModel>();

const image = components?.find(
    (component) => component.alias === 'imageItem'
) as ImageComponentModel;

const faq = components?.find((component) => component.alias === 'faqBlock') as FaqComponentModel;

const text = components?.find(
    (component) => component.alias === 'textBlock'
) as TextBlockComponentModel;
</script>
